// ** React Imports

// ** Next Imports

// ** MUI Imports

// ** Icons Imports

// ** Third Party Imports

// ** Axios

// ** Hook Imports
import useCrypto from './useCrypto'

// ** Configs
import authConfig from 'src/configs/endpoints/authEndPoints'

// ** Custom Imports

// ** Types
import { UserDataType } from 'src/context/types'

interface Payload {
    url: string
    body: any
    Authorization?: string
}

const debugLog = (options: {
    type: 'GET' | 'POST'
    url?: string
    payload?: any
    result?: any
    error?: Error
}) => {

    const styles = {
        GET: 'color:rgb(255, 247, 0); font-weight: bold;', // Blue
        POST: 'color: #16a34a; font-weight: bold;' // Green
    }

    console.group(`%c[Fetch ${options.type.toUpperCase()}] - ${options.payload.url || ''}`, styles[options.type])

    if (options.payload) {
        console.log('Payload:', options.payload)
        console.log('Result:', options.result)
    }

    if (options.error) {
        console.error('Error:', options.error)
    }

    console.groupEnd()
}

const FetchWithPayload = async ([url, payload]: [url: string, payload: Payload]) => {
    const { encryptURI, decryptURI, decrypt } = useCrypto()
    const encryptedData = window.localStorage.getItem(authConfig.storageKeyName)
    const storedData: UserDataType | undefined = encryptedData ? JSON.parse(decrypt(encryptedData)) : undefined

    const Authorization = storedData ? `Bearer ${storedData.bearer_token}` : ''
    const payloadWithAuth = {
        ...payload,
        Authorization
    }
    const encryptedPayload = encryptURI(JSON.stringify(payloadWithAuth))

    const res = await fetch(url, {
        method: 'POST',
        body: encryptedPayload,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
    })
    const data = await res.text()
    const decryptedData = decryptURI(data)
    const jsonData = JSON.parse(decryptedData)
    if (storedData?.role_id == '5') {
        debugLog({
            type: 'GET',
            url,
            payload: payloadWithAuth,
            result: jsonData
        })
    }

    return jsonData
}

const ReqWithPayload = async (url: string, { arg }: { arg: any }) => {
    const { encryptURI, decryptURI, decrypt } = useCrypto()
    const encryptedData = window.localStorage.getItem(authConfig.storageKeyName)
    const storedData: UserDataType | undefined = encryptedData ? JSON.parse(decrypt(encryptedData)) : undefined

    const Authorization = storedData ? `Bearer ${storedData.bearer_token}` : ''
    const argWithAuth = {
        ...arg,
        Authorization
    }
    const encryptedPayload = encryptURI(JSON.stringify(argWithAuth))

    const res = await fetch(url, {
        method: 'POST',
        body: encryptedPayload,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
    })
    const data = await res.text()
    const decryptedData = decryptURI(data)
    const jsonData = JSON.parse(decryptedData)
    if (storedData?.role_id == '5') {
        debugLog({
            type: 'POST',
            url,
            payload: argWithAuth,
            result: jsonData
        })
    }

    return jsonData
}

const useFetch = () => {
    return { FetchWithPayload, ReqWithPayload }
}

export default useFetch
